import Quagga from 'quagga';

(function ($, $win) {
  function BarcodeScanner(options) {
    $.extend(true, this, {
      targetSelector: '#barcode-interactive',
      cameraSelector: '#deviceSelection',
      torchSelector: '#torchSelector',
      accuracy: 40,
      state: {
        inputStream: {
          name: 'Live',
          type: 'LiveStream',
          constraints: {
            width: { min: 640 },
            height: { min: 480 },
            facingMode: 'environment',
            aspectRatio: { min: 1, max: 2 },
          },
        },
        locator: {
          patchSize: 'medium',
          halfSample: true,
        },
        // frequency: 10,
        decoder: {
          readers: [{
            format: 'ean_reader',
            config: {},
          }],
        },
        locate: true,
      },
      lastResults: [],
    }, options);
  }

  $.extend(true, BarcodeScanner.prototype, {
    init(state) {
      const self = this;

      self.lastResults = [];
      self.state.inputStream.target = $(self.targetSelector).get(0);

      $.extend(true, self.state, state);

      Quagga.init(self.state, (err) => {
        if (err) {
          return self.handleError(err);
        }
        self._attachListeners();
        self._checkCapabilities();
        Quagga.onProcessed(self._onProcessed.bind(self));
        Quagga.onDetected(self._onDetected.bind(self));
        Quagga.start();
      });
    },
    stop() {
      const self = this;

      self._detachListeners();
      Quagga.stop();
      Quagga.offProcessed();
      Quagga.offDetected();
    },
    handleError(err) {
      alert(err);
    },
    applySetting(setting, value) {
      const track = Quagga.CameraAccess.getActiveTrack();
      if (track && typeof track.getCapabilities === 'function') {
        const capabilities = track.getCapabilities();
        switch (setting) {
          case 'zoom':
            return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
          case 'torch':
            return track.applyConstraints({ advanced: [{ torch: capabilities.torch && !!value }] });
        }
      }
    },
    updateState(state) {
      const self = this;

      self.stop();
      setTimeout(() => {
        self.init(state);
      }, 500);
    },
    _checkCapabilities() {
      const track = Quagga.CameraAccess.getActiveTrack();
      let capabilities = {};
      if (typeof track.getCapabilities === 'function') {
        capabilities = track.getCapabilities();
      }
      this._applySettingsVisibility('torch', capabilities.torch);
    },
    _applySettingsVisibility(setting, capability) {
      const self = this;

      if (setting === 'torch') {
        $(self.torchSelector).closest('label').toggle(!!capability);
      }
    },
    _initCameraSelection() {
      const self = this;

      const streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

      return Quagga.CameraAccess.enumerateVideoDevices()
        .then((devices) => {
          function pruneText(text) {
            return text.length > 30 ? text.substr(0, 30) : text;
          }
          const $deviceSelection = $(self.cameraSelector);
          $deviceSelection.empty();
          devices.forEach((device) => {
            const $option = document.createElement('option');
            $option.value = device.deviceId || device.id;
            $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
            $option.selected = streamLabel === device.label;
            $deviceSelection.append($option);
          });
          jcf.replaceAll();
        });
    },
    _attachListeners() {
      const self = this;

      self._initCameraSelection();

      $(self.cameraSelector).on('change', function (e) {
        e.preventDefault();
        self.updateState({ inputStream: { constraints: { deviceId: $(this).val() } } });
      });

      $(self.torchSelector).on('change', function (e) {
        e.preventDefault();
        self.applySetting('torch', $(this).is(':checked'));
      }).trigger('change');
    },
    _detachListeners() {
      const self = this;

      $(self.cameraSelector).off('change');
      $(self.torchSelector).off('change');
    },
    _onProcessed(result) {
      const drawingCtx = Quagga.canvas.ctx.overlay;
      const drawingCanvas = Quagga.canvas.dom.overlay;

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
        }
      }
    },
    _onDetected(result) {
      const self = this;

      const { code } = result.codeResult;
      self.lastResults.unshift(code);

      if (self.lastResults.length < self.accuracy) {
        return;
      }

      const mostPopularCode = self._modeArray(self.lastResults);
      self.lastResults = [];

      // alert(mostPopularCode);
      if (typeof self.onDetected === 'function') {
        self.onDetected(mostPopularCode);
      }
    },
    _modeArray(array) {
      if (array.length == 0) {
        return null;
      }
      const modeMap = {};
      let maxEl = array[0]; let
        maxCount = 1;
      for (let i = 0; i < array.length; i++) {
        const el = array[i];
        if (modeMap[el] == null) {
          modeMap[el] = 1;
        } else {
          modeMap[el]++;
        }
        if (modeMap[el] > maxCount) {
          maxEl = el;
          maxCount = modeMap[el];
        }
      }
      return maxEl;
    },
  });

  window.BarcodeScanner = BarcodeScanner;
}(jQuery, jQuery(window)));
